import { preCheckEvent, endStudentPreChecks, startStudentPreChecks, preCheckItemFinished, preCheckItemErrored, updateTroubleshootData, updateCheckData, preCheckItemStarted } from "./studentPreChecksSlice";
import { STUDENT_PRE_CHECK_STATUS } from './constants'
import handlePreCheckItemFinished from "./eventHandlers/handlePreCheckItemFinished";
import handleAddToLogStack from "./eventHandlers/handleAddToLogStack";
import speechActions from "../Reader/Speech/state/actions";
import speechTypes from '../Reader/Speech/state/constants'
import {logPreCheckEvent, logEndStudentPreChecks, logPreCheckItemErrored, logStartStudentPreChecks, logTroubleshootData } from "./functions/readyModuleLoggers";
import handlePreCheckEvents from "./eventHandlers/handlePreCheckEvents";

export function resetStudentPreChecksMiddlewareListeners(listenerMiddleware){
  listenerMiddleware.clearListeners();
  addStudentPreChecksMiddlewareListeners(listenerMiddleware);
}

export function addStudentPreChecksMiddlewareListeners(listenerMiddleware) {
  listenerMiddleware.startListening({
    actionCreator: startStudentPreChecks,
    effect: async (action, listenerApi) => {
      logStartStudentPreChecks(action, listenerApi)
      // unsubscribe to only run once.
      listenerApi.unsubscribe();
    }
  });

  listenerMiddleware.startListening({
    actionCreator: preCheckItemStarted,
    effect: async (action, listenerApi) => {
      handleAddToLogStack(action, listenerApi, "CHECK_STARTED")
    }
  });
  
  listenerMiddleware.startListening({
    actionCreator: preCheckItemFinished,
    effect: async (action, listenerApi) => {
      handleAddToLogStack(action, listenerApi, "CHECK_ENDED")
    }
  })

  listenerMiddleware.startListening({
    predicate: (action, currentState, previousState) => {
      if (action.type === "studentPreChecks/preCheckItemFinished") { 
        var currentStateSuccess =  currentState.studentPreChecks.contextStates.checks[action.payload.item] === STUDENT_PRE_CHECK_STATUS.success;
        var prevCheckStatus = previousState.studentPreChecks.contextStates.checks[action.payload.item];
        var prevStatePending = prevCheckStatus === STUDENT_PRE_CHECK_STATUS.pending; // check if it did enter into pending state, not async_pending state.
        var prevStateFailed = prevCheckStatus === STUDENT_PRE_CHECK_STATUS.failed;  // check if it failed and now being called because it recovered.
        return currentStateSuccess && (prevStatePending || prevStateFailed);
      }
      return false
    },
    effect: async (action, listenerApi) => {
      handlePreCheckItemFinished(listenerApi, action.payload.item)
    }
  })

  listenerMiddleware.startListening({
    actionCreator: preCheckItemErrored,
    effect: async (action, listenerApi) => {
      // report or log errors here
      logPreCheckItemErrored(action, listenerApi)
      // add troubleshoot data
      listenerApi.dispatch(updateTroubleshootData({
        type: action.payload.item,
        data: action.payload.errorObject
      }))
    }
  });

  listenerMiddleware.startListening({
    actionCreator: endStudentPreChecks,
    effect: async (action, listenerApi) => {
      logEndStudentPreChecks(action, listenerApi);
      // unsubscribe to only run once.
      listenerApi.unsubscribe();
    }
  });

  listenerMiddleware.startListening({
    actionCreator: updateTroubleshootData,
    effect: async (action, listenerApi) => {
      logTroubleshootData(action, listenerApi)
    }
  });

  listenerMiddleware.startListening({
    actionCreator: updateCheckData,
    effect: async (action, listenerApi) => {
      if(action.payload.data){
        if(action.payload.data.isMeasuringVolume !== undefined){
          listenerApi.dispatch(speechActions[speechTypes.IS_LISTENING_CHANGE](action.payload.data.isMeasuringVolume))
        }
      }
    }
  });

  listenerMiddleware.startListening({
    actionCreator: preCheckEvent,
    effect: async (action, listenerApi) => {
      logPreCheckEvent(action, listenerApi)
      handlePreCheckEvents(action.payload.event, listenerApi)
    }
  });
}
